// extracted by mini-css-extract-plugin
export default {"premiumModal":"styles_premiumModal__ONxdi","btnBlock":"styles_btnBlock__z14Re","mainBtn":"styles_mainBtn__F6Z3E"};